export default "__VITE_ASSET__C0I1$v6r__"